import { Button, Color, Kind } from '@usitsdasdesign/dds-react';
import Text from 'atoms/Text';
import Dialog from 'molecules/Dialog';
import { useState } from 'react';
import useGlobalToastStore from 'store/globalToastStore';

function ExportCSV({
    onExport,
    isExportAlert = false,
    customMessage = null,
    isExportDisabled = false,
    showIconOnly = false
}) {
    const { setToastData } = useGlobalToastStore();
    const [showDialog, setShowDialog] = useState(false);
    return (
        <>
            <Button
                icon='external_link__l__stroke'
                kind='primary'
                size='l'
                label= {!showIconOnly ? 'Export' : ''}
                onClick={() => {
                    isExportAlert ? setShowDialog(true) : onExport();
                }} 
                className={`only-icon-mobile btn-sm-mobile ${isExportDisabled ? 'opacity-50 pointer-events-none' : ''}`}
            />

            <Dialog
                show={showDialog}
                title={'Export'}
                actions={[
                    {
                        label: 'No',
                        size: 'l',
                        kind: Kind.secondaryLoud,
                        color: Color.green,
                        onClick: () => {
                            setShowDialog(false);
                            setToastData({ show: true, message: `Export cancelled `, type: 'error' });
                        }
                    },
                    {
                        label: 'Yes',
                        size: 'l',
                        kind: Kind.primaryLoud,
                        color: Color.green,
                        isDisabled: false,
                        onClick: () => { onExport(); setShowDialog(false) }
                    }
                ]}
                onClose={() => setShowDialog(false)}
                size={'md'}
            >{  customMessage ? customMessage:
                <>
                    <Text variant='body'>Since the file size is large, the file will be shared to your inbox instead. Do you wish to proceed?</Text>
                    <Text variant='body' className='mt-4'>Note : The file may take some time to reach your inbox. Please refresh your inbox before exporting again.</Text>
                </>
                }
            </Dialog>
        </>
    );
}

export default ExportCSV;
